<div class="not-found-container">
  <div class="not-found-card">
    <app-not-found-svg />

    <h1 class="not-found-title">
      No encontramos la página que buscas
    </h1>

    <p class="not-found-text">
      Todos los días estamos trabajando por mejorar la plataforma, por el momento te recomendamos volver al Panel principal.
    </p>

    <button horusBtn horusBtnVariant="default" horusBtnSize="md" (click)="goToPanel()">
      IR AL PANEL
    </button>
  </div>
</div>
